import {createSlice} from '@reduxjs/toolkit';



const initialState = {
    Cars : ["Model S" , "Model Y" , "Model 3", "Model X"]
}


const carSlice = createSlice({
    name: "car",
    initialState,
    reducers: {}
})


export const selectCars = state=>state.car.Cars

export default carSlice.reducer